<template>
    <div class="container">
    <h1>403</h1>
    <p>Access denied</p>
    </div>
</template>

<script>
export default {
    name: 'error403'
}
</script>

<style>
body{
    background-color: yellow;
}
h1, p {
    font-size: 50px;
    text-align: center;
    font-weight: 100;
    margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/error403.vue